import { AssetsContext } from "providers/Assets";
import { SideMenuLeft } from "components/SideMenu/SideMenu.index";
import { PagesContext } from "providers/Pages";
import { DrawersContext } from "providers/DrawersProvider";
import React, { useContext } from "react";
import axios from "axios";
import { SessionData } from "providers/Session";
import {  parseCookies } from "nookies";
import { removeSessionDataCookie } from "providers/Session/utils";
import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";

declare global {
  interface Window {
    tp: any;
  }
}

const RenderSideMenu = () => {
  const pagesContext = useContext(PagesContext);
  const cookies = parseCookies();
  const sessionData = JSON.parse(cookies.sessionData || "{}") as SessionData;
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const { assets } = useContext(AssetsContext);
  const { handleSideMenuLeft, sideMenuLeftState } = useContext(DrawersContext);
  const sideMenuItems = pagesContext?.navigation?.menuSide || [];
  const routerRedirectUrl = window.location.href;

  const handleClose = () => {
    handleSideMenuLeft({ open: !sideMenuLeftState.open });
  };

  async function keycloakSessionLogOut(id) {
    return await axios.delete(`/paywall/delete-sessao/${id}`);
  }

  const handleLogin = async () => {
    try {
      await keycloak?.login({
        redirectUri: `${window.location.href}`,
      });
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  return (
    <SideMenuLeft
      assets={assets}
      close={handleClose}
      open={sideMenuLeftState.open}
      onLogin={handleLogin}
      onLogout={() => {
        if (sessionData?.id == undefined) {
          keycloak?.logout();
        } else {
          keycloakSessionLogOut(sessionData.id).then((res) => {
            if (res.status == 200) {
              keycloak?.logout();
              removeSessionDataCookie();
            } else {
              console.log("Erro ao fazer login");
            }
          });
        }
      }}
      navItems={sideMenuItems}
      variant={sessionData?.id ? "ASSINANTE" : "anonymous"}
    />
  );
};

export default RenderSideMenu;
